// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-D":"D_power-ocean-home-D__umQ_N"};